import { useUserInfo } from "@next-platform/client-common-core";

import CheckoutForm from "@/components/Checkout/CheckoutForm";

const Checkout = () => {
  const { onlyUserId: user_id } = useUserInfo();
  if (!user_id) {
    return null;
  }

  return (
    <div className="flex justify-center">
      <CheckoutForm />
    </div>
  );
};

export default Checkout;
